import { FormType } from 'models/FormType';
import { CustomerSupportFormSendEvent } from '../types';

export const getSubmitFormEvent = (form: FormType, page: string): CustomerSupportFormSendEvent => {
  return {
    event: 'customer_support_form_submit',
    form: FormType[form],
    page
  };
};
